<template>
  <div>
    <!-- 新增服务单 -->
    <el-dialog :title="$t('message.addServiceOrder')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1600px" center>
      <div class="content">
        <!-- 服务单号 -->
        <div class="service_sn row">
          <div class="label">{{ $t('message.serviceOrderNumber') }}:</div>
          <div class="value">{{ detail.service_sn }}</div>
        </div>
        <div class="FBA row">
          <div class="label">FBA:</div>
          <div class="value">{{ porderDetail.fba_name }}</div>
          <!-- 服务操作人 -->
          <div class="label">{{ $t('message.serviceOperator') }}:</div>
          <div class="value">
            <el-select v-model="datas.adminId" clearable placeholder="请选择" filterable>
              <el-option v-for="item in adminLis" :key="item.id" :label="item.realname" :value="item.id">
              </el-option>
            </el-select>
          </div>

        </div>
        <div class="table">
          <ol>
            <!-- 订单号 -->
            <li class="flex15">{{ $t("message.orderNumber") }}</li>
            <!-- 番号 -->
            <li class="flex05">
              {{ $t("message.mash") }}
            </li>
            <!-- 照片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 业务编辑商品属性 -->
            <li class="flex2">
              {{ $t("message.theBusinessEditsTheCommodityProperties") }}
            </li>
            <!-- 附加服务 -->
            <li class="flex2">
              {{ $t("message.additionalServices") }}
            </li>
            <!-- 配套
              -->
            <li>
              <div>
                {{ $t("message.supportingFacilities") }}
                <p>({{ total.pack_should }})</p>
              </div>
            </li>
            <!-- 包气泡膜（100） -->
            <li>
              <div>
                {{ $t("message.bubbleWrapFilm") }}
                <p>({{ total.bubble_should }})</p>
              </div>
            </li>
            <!-- 塑封（0） -->
            <li>
              <div>
                {{ $t("message.plasticSealing") }}
                <p>({{ total.pseal_should }})</p>
              </div>
            </li>
            <!-- 真空压缩（100） -->
            <li>
              <div>
                {{ $t("message.vacuumCompression") }}
                <p>({{ total.vacuum_should }})</p>
              </div>
            </li>
            <!-- 折盒子 -->
            <li>
              <div>
                {{ $t("message.foldBox") }}
                <p>({{ total.fold_should }})</p>
              </div>
            </li>
            <!-- 价格.元 -->
            <li>
              {{ $t("message.priceY") }}
            </li>
            <!-- 担当备注 -->
            <li class="flex15">
              {{ $t("message.responsibleForRemarks") }}
            </li>
            <!-- 采购备注 -->
            <li class="flex15">
              {{ $t("message.purchasingNotes") }}
            </li>
            <!-- 核查员备注 -->
            <li class="flex15">
              {{ $t("message.verifierSNotes") }}
            </li>
          </ol>
          <ul v-for="(item, index) in detail.detail" :key="index">
            <!-- 订单号 -->
            <li class="flex15">
              <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                {{ item.order_sn }}
              </router-link>
            </li>
            <!-- 番号 -->
            <li class="flex05">
              {{ item.sorting }}
            </li>
            <!-- 照片 -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!-- 业务编辑商品属性 -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 附加服务 -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom" style="max-height: 100px">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 配套（300） -->
            <li>
              <el-input type="number" v-model="item.pack_should" @blur="calculateTotal"
                @input="handleInput($event, item, 'pack_should', 'pack_should_max')" onfocus="this.select()"
                v-if="item.is_pack_should"></el-input>
            </li>
            <!-- 包气泡膜（100） -->
            <li>
              <el-input type="number" v-model="item.bubble_should" @blur="calculateTotal"
                @input="handleInput($event, item, 'bubble_should', 'bubble_should_max')" onfocus="this.select()"
                v-if="item.is_bubble_should"></el-input>
            </li>
            <!-- 塑封（0） -->
            <li>
              <el-input type="number" v-model="item.pseal_should" @blur="calculateTotal"
                @input="handleInput($event, item, 'pseal_should', 'pseal_should_max')" onfocus="this.select()"
                v-if="item.is_pseal_should"></el-input>
            </li>
            <!-- 真空压缩（100） -->
            <li>
              <el-input type="number" v-model="item.vacuum_should" @blur="calculateTotal"
                @input="handleInput($event, item, 'vacuum_should', 'vacuum_should_max')" onfocus="this.select()"
                v-if="item.is_vacuum_should"></el-input>
            </li>
            <!-- 折盒子 -->
            <li>
              <el-input type="number" v-model="item.fold_should" @blur="calculateTotal"
                @input="handleInput($event, item, 'fold_should', 'fold_should_max')" onfocus="this.select()"
                v-if="item.is_fold_should"></el-input>
            </li>
            <!-- 价格.元 -->
            <li>
              {{ item.confirm_price }}
            </li>
            <!-- 担当备注 -->
            <li class="flex15">
              {{ item.y_remark }}
            </li>
            <!-- 采购备注 -->
            <li class="flex15">
              {{ item.g_remark }}
            </li>
            <!-- 核查员备注 -->
            <li class="flex15">
              {{ item.p_remark }}
            </li>
          </ul>
        </div>
        <div class="btn">
          <!-- 提交给检品 -->
          <el-button type="primary" @click="optionServiceStore(0)">
            {{ $t('message.submitToInspection') }}
          </el-button>
          <!-- 操作完了 -->
          <el-button type="success" @click="optionServiceStore(1)" v-if="isAuth(591)">
            {{ $t('message.operationCompleted') }}
          </el-button>
        </div>
        <!-- 底部 -->
        <div class="footer">
          <!-- 注意事项-->
          <div class="label">
            {{ $t('message.mattersNeedingAttention') }}:
          </div>

          <div class="text">
            <el-input type="textarea" v-model="datas.remark"></el-input>
          </div>
          <!-- 服务单附件： -->
          <div class="label">
            {{ $t('message.serviceOrderAttachment') }}:
          </div>
          <div class="file">
            <div class="file-list">
              <a :href="item" target="_blank" rel="noopener noreferrer" v-for="(item, index) in datas.file" :key="index"
                :title="item">
                <i class="el-icon-folder-checked"></i>
              </a>
            </div>
            <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
              :http-request="httpup" drag>

              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {

  computed: {
    ...mapState({
      porderDetail: (state) => state.porderDetail.detail,
    }),
  },
  data() {
    return {
      detail: {
        detail: []
      },
      total: {

      },
      adminLis: [],
      datas: {

      },
      dialogVisible: false,
    };
  },
  watch: {
    dialogVisible() {
      this.datas = {
        service_sn: '',
        porder_sn: '',
        adminId: '',
        remark: '',
        file: [],
        serviceDetail: []
      }
      if (this.dialogVisible) {
        this.usableAdminList()
      }
    },
  },
  methods: {
    // 服务单-新增预览
    optionServicePreview(datas) {
      this.$api.inspectionApi.optionServicePreview(datas).then(res => {
        res.data.detail.forEach(item => {
          if (item.option) {
            let itemData = item.option.find(opti => opti.name == '配套')
            if (itemData) {
              item.pack_should_max = item.pack_should
              item.is_pack_should = true
            }
            let itemData1 = item.option.find(opti => opti.name == '气泡膜')
            if (itemData1) {
              item.bubble_should_max = item.bubble_should
              item.is_bubble_should = true
            }
            let itemData2 = item.option.find(opti => opti.name == '塑封')
            if (itemData2) {
              item.pseal_should_max = item.pseal_should
              item.is_pseal_should = true
            }
            let itemData3 = item.option.find(opti => opti.name == '真空压缩')
            if (itemData3) {
              item.vacuum_should_max = item.vacuum_should
              item.is_vacuum_should = true
            }
            let itemData4 = item.option.find(opti => opti.name == '更换定制包装')
            if (itemData4) {
              item.fold_should_max = item.vacuum_should
              item.is_fold_should = true
            }
          }
        })
        this.detail = res.data
        this.datas.service_sn = res.data.service_sn
        this.datas.porder_sn = res.data.porder_sn

        this.calculateTotal()
      })
    },
    //服务单-可选检品操作人员
    usableAdminList() {
      this.$api.inspectionApi.usableAdminList().then(res => {
        let fba = res.data.find(item => item.realname == this.porderDetail.fba_name)
        this.adminLis = res.data
        if (fba) {
          this.datas.adminId = fba.id
        }

      })
    },
    // 计算总数
    calculateTotal() {
      this.total = {
        "pack_should": 0, //配套数
        "bubble_should": 0, //包气泡膜数
        "pseal_should": 0, //塑封数
        "vacuum_should": 0,//真空压缩数
        "fold_should": 0 //更换定制包装
      }
      this.detail.detail.forEach(item => {
        this.total.pack_should += item.pack_should - 0
        this.total.bubble_should += item.bubble_should - 0
        this.total.pseal_should += item.pseal_should - 0
        this.total.vacuum_should += item.vacuum_should - 0
        this.total.fold_should += item.fold_should - 0

      })
    },
    handleInput(value, item, type, max) {
      // 将输入值转换为数字，然后去除开头的负号
      const number = Number(value.replace(/^-/, ''));
      // 如果输入的是负数或者非数字，则清空输入
      if (isNaN(number) || number < 0) {
        item[type] = '';
      } else {
        // 否则更新输入值
        item[type] = number.toString();
      }
      // 最大值不能超过接口的
      if (item[type] > item[max]) {
        item[type] = item[max]
      }
    },
    // 文件上传事件
    async httpup(file) {
      let data = await this.createClient(file)
      this.datas.file.push(data.data)
    },
    //新增服务单保存
    optionServiceStore(type) {
      this.datas.autoComplete = type
      this.datas.serviceDetail = []
      if (this.datas.adminId == '') return this.$message.error('未选择服务操作人')
      const shouldProperties = ['pack_should', 'bubble_should', 'pseal_should', 'vacuum_should', 'fold_should'];
      this.detail.detail.forEach(item => {
        if (shouldProperties.some(prop => item[prop] > 0)) {
          this.datas.serviceDetail.push({
            order_detail_id: item.id,
            pack_should: item.pack_should,
            bubble_should: item.bubble_should,
            pseal_should: item.pseal_should,
            vacuum_should: item.vacuum_should,
            fold_should: item.fold_should
          })
        }
      })
      if (this.datas.serviceDetail == false) return this.$message.error('提出的服务单数量不能全为0')
      if (type == 0) {
        this.$api.inspectionApi.optionServiceStore(this.datas).then(res => {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$parent.checked = false;
        })
      } else {
        this.$confirm(
          '是否提交服务单直接完成？',
          this.$t("message.hint"),
          {
            confirmButtonText: this.$t("message.ok"), //确定
            cancelButtonText: this.$t("message.cancel"), //取消
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$api.inspectionApi.optionServiceStore(this.datas).then(res => {
              this.$message.success(res.msg)
              this.dialogVisible = false
              this.$parent.checked = false;
            })
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      }
    },

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  position: relative;

  .row {
    display: flex;
    margin-bottom: 20px;
    line-height: 32px;

    .label {
      width: 100px;
    }

    .value {
      width: 200px;
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;

      li {
        text-align: center;

        p {
          color: red;
        }
      }
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border-bottom: 0;
      }

      li {
        padding: 12px 3px;

        .template {
          width: 100%;
          overflow: hidden;

          .row {
            line-height: 20px;
            margin-bottom: 5px;
          }
        }
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }
  }

  .btn {
    background-color: #edeff4;
    height: 80px;
    line-height: 80px;
    text-align: right;
    position: sticky;
    bottom: 0;
    left: 0;
    padding-right: 20px;
  }

  .footer {
    display: flex;
    padding: 20px;
    background-color: #f0f9eb;

    .label {
      width: 100px;

    }

    .text {
      width: 200px;
      margin-right: 48px;

      /deep/.el-textarea__inner {
        height: 120px;
      }
    }

    .file {
      flex: 1;
      display: flex;

      /deep/.el-upload-dragger {
        width: 120px;
        height: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #ccc;
        border-radius: 4px;

        i {
          font-size: 30px;
        }
      }

      .file-list {
        i {
          font-size: 100px;
          margin-right: 20px;
          color: #b4272d;
        }
      }
    }
  }


  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>